import { makeStyles } from '@material-ui/core/styles';
import { BLACK_FONT_COLOR, X_SMALL_TEXT_PX, FONT_FAMILY_REGULAR } from '../../../styles/fonts/MCFontConstants.js';

const useStyles = makeStyles((theme) => ({
    root: ({
        font,
        fontFamily,
        height,
        mobilePadding,
        borderRadius,
        isFromAutoComplete,
        color,
        mobileMargin,
        position,
        bottom,
        right,
        desktopPadding,
        desktopMargin,
        marginLeft
    }) => ({
        display: 'flex',
        justifyContent: 'left',
        font: font ? font : X_SMALL_TEXT_PX,
        fontFamily: fontFamily ? fontFamily : FONT_FAMILY_REGULAR,
        letterSpacing: '-0.1px',
        opacity: '1',
        height: height ? height : '21px',
        fontWeight: 'normal',
        '& > *': {
            background: '#E8E8E8',
            padding: mobilePadding ? mobilePadding : '4px 3px',
            borderRadius: borderRadius ? borderRadius : '17px',
            cursor: isFromAutoComplete ? 'text' : 'pointer',
            color: color ? color : BLACK_FONT_COLOR,
            margin: mobileMargin ? mobileMargin : '6px',
            marginLeft: marginLeft ? marginLeft : '',
            position: position,
            bottom: bottom,
            right: right,
            [theme.breakpoints.up(426)]: {
                padding: desktopPadding ? desktopPadding : '4px 20px',
                margin: desktopMargin ? desktopMargin : '6px',
            },
        },
    }),
}));

export default useStyles;
